import React, {Fragment} from 'react'
import BrainstormPrompt from './BrainstormPrompt'
import BrainstormResponse from './BrainstormResponse'

export default function ChatItem({chatId, chat}) {
  return <Fragment>
    <BrainstormPrompt chatId={chatId} prompt={chat?.prompt} />
    <BrainstormResponse chatId={chatId} response={chat?.response} />
  </Fragment>
}